import axios from '../../axios'

export const getLiveUrl = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/live-support`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }